import Vue from 'vue'
export default new Vue;



//////////////////
// WEBPACK FOOTER
// ./static/js/bus.js
// module id = null
// module chunks = 